// extracted by mini-css-extract-plugin
module.exports = {"links":"Socials_links__zr65d","hvr-bob":"Socials_hvr-bob__9aTf4","hvr-bob-float":"Socials_hvr-bob-float__hflwP"};